import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchData } from 'src/app/services/searchData';
import { User } from 'src/app/types/User';
import { UserCardConfig } from 'src/app/types/UserCardConfig';
import Swal from "sweetalert2";
import { ApiService } from './../../../services/api.service';
import { UtilService } from './../../../services/util.service';
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, Subject } from 'rxjs';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { WidgetModule } from '../../../widget/widget.module';
import { UserCardComponent } from '../../cards/user-card/user-card.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-invite-member',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule,
NodataFoundComponent, WidgetModule, UserCardComponent, InfiniteScrollModule, CommonSkeletonComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './invite-member.component.html',
  styleUrls: ['./invite-member.component.scss']
})
export class InviteMemberComponent   implements OnInit , OnDestroy{
  pathdata;
  inviteLength;
  values: any = {
    getInviteList: [],
  };
  ownerFlag: boolean = false;
  membersData: any;
  teamMembersSearch:any;
  userCardConfig: UserCardConfig[] = [];
  commonVariables: any = {};
  showNoDatafound: boolean = false;
  noDatafound : Array<string> = ["You have no invitations sent lately"];
  tempmembersData:any;
  membersList = new BehaviorSubject<any[]>([])
  invitePayload = {
    networkId: null,
    limit: 10,
    searchAfterKey: null,
    searchContent: null,
    status :"REQUEST_SENT",
  }

  searchKey
  stopScroll : boolean = false;
  previouseAfterKey : any = null;
  searchSubject = new Subject<string>();
  scrollSubject = new BehaviorSubject<string>(null);
   loadScroll: boolean;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private SearchData: SearchData,
    private api: ApiService,
    private util: UtilService
  ) {}
  ngOnDestroy(): void {
    this.searchSubject.unsubscribe();
    this.scrollSubject.unsubscribe();
  }


  ngOnInit() {
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.queryParams.subscribe((res) => {

      this.pathdata = res;
      if (res.networkId == undefined) {
        // this.pathdata.teamId = null;
      }
      if (localStorage.getItem("userId") == this.pathdata.networkOwnerId) {
        this.ownerFlag = true;
        let revokeBtn: UserCardConfig = new UserCardConfig(
          "Cancel Invitation",
          this.cancelInvite,
          this.canShow,
          true
        );
        revokeBtn.source = this;
        this.userCardConfig.push(revokeBtn);
      } else {
        this.ownerFlag = false;
      }
    });
    // if (this.pathdata.teamId != "") {
    this.getInviteList();
    // }

    this.searchSubject.pipe(
      debounceTime(500),
      map((res: string) => (res || '').trim().replace(/\s+/g, ' ')),
      distinctUntilChanged()
    ).subscribe(res=>{
      if (res === (this.invitePayload.searchContent || '')) { return; } // skip whitespace-only / unchanged searches
      this.loadScroll = false;
      this.resetPayload();
      this.invitePayload.searchContent = res || null;
      this.getInviteList();
    });

    this.scrollSubject.pipe(
      debounceTime(100),
      distinctUntilChanged()
    ).subscribe(res=>{
      if(res!=null){
        this.invitePayload.searchAfterKey = this.previouseAfterKey;
        this.getInviteList();
      }
    })
  }

  resetPayload(){
    this.membersList.next([]);
    this.invitePayload.searchAfterKey = null;
    this.previouseAfterKey = null;
    this.stopScroll = false;
  }
  keyupdata(event){
    if(event.target.value.length==0){
      this.onsearch('');
    }
  }
  onsearch(val) {
     if(val!=undefined){
      val = val.trim().toLowerCase();
    }
     this.membersData =this.tempmembersData
     this.membersData = this.filterByString(this.membersData, val);
    if (this.membersData.length == 0) {
      this.showNoDatafound = true;
    } else {
      this.showNoDatafound = false;
    }

  }
  filterByString(data, s) {
    return data.filter(e => e.userName.toLowerCase().includes(s))
      .sort((a, b) => a.userName.toLowerCase().includes(s) && !b.userName.toLowerCase().includes(s) ? -1 : b.userName.toLowerCase().includes(s) && !a.userName.toLowerCase().includes(s) ? 1 : 0);
 }
  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    }
  }

  sendMessage(user: User) {
    var userData: any = {};
    userData.groupId = user.userId;
    userData.type = "USER";
    this.router.navigate(["message"], { queryParams: userData });
  }


  connect(user: User) {

  }

  loadAPIcall:boolean=false
  getInviteList() {
    this.loadAPIcall=true;
    this.util.startLoader();
    this.invitePayload.networkId = this.pathdata.networkId;
    const requestSearchContent = this.invitePayload.searchContent;
    this.api.create("network/member",this.invitePayload).subscribe((res) => {
        console.log("invite....." );
        this.loadAPIcall=false;
        this.membersData = "";
        this.loadScroll = false;
        if (requestSearchContent !== this.invitePayload.searchContent) { return; } // stale: search mode changed mid-flight
        if(res.code === GigsumoConstants.SUCESSCODE){

          const data = res.data.membersList;
          const searchAfteKey = res.data.searchAfterKey;

          if((data && data.length === 0) || JSON.stringify(this.previouseAfterKey) === JSON.stringify(searchAfteKey)){
            this.stopScroll = true;
          }

            const current = res.data.membersList;
            const exist = this.membersList.getValue();

            // Filter out duplicates by userId so a re-fetched page never renders the same invite twice
            const existingUserIds = new Set(exist.map(member => member.userId));
            const newMembers = current.filter(member => !existingUserIds.has(member.userId));

            const combined = [...exist , ...newMembers];

            this.membersList.next(combined);
            this.previouseAfterKey = searchAfteKey;

            this.membersData = this.membersList.getValue().length ;



          this.tempmembersData = this.membersList.getValue();
          this.previouseAfterKey = searchAfteKey;

          if (res.data.totalElements!== undefined) {
                this.inviteLength = res.data.totalElements;
            }

          if (!this.invitePayload.searchContent) { // badge shows the full pending count, not search matches
            this.commonVariables.pendingCount = this.inviteLength;
            this.SearchData.setCommonVariables(this.commonVariables);
          }

          const memberData = structuredClone(this.tempmembersData);
          if(memberData){
            memberData.forEach(element => {
            let buttonConfig: UserCardConfig[] = [];
            element.userName = element.firstName + " " + element.lastName;
              if ((element.connectionStatus == "CONNECTED" || element.connected)) {
                let sendMessage: UserCardConfig = new UserCardConfig(
                  "Send Message",
                  this.sendMessage,
                  null,
                  true
                );
                sendMessage.source = this;
                buttonConfig.push(sendMessage);
              }else if (element.connectionStatus == "NOT_CONNECTED" || !element.connected){
                 let connect: UserCardConfig = new UserCardConfig(
                  "Connect",
                  this.connect,
                  null,
                  true
                );
                connect.source = this;
                buttonConfig.push(connect);
              }
            });
          }
           
        }
      },err => {
        this.util.stopLoader();
      });
    this.util.stopLoader();
  }

  cancelInvite(data) {
    const obj: any = {};
    obj.networkId = this.pathdata.networkId;
    obj.memberUserId =data.userId;
    this.api.create("network/cancel/invite", obj).subscribe((res) => {
      if (res.code == "00000") {
        // Immediately remove the cancelled invite from the local list
        const currentMembers = this.membersList.getValue();
        const updatedMembers = currentMembers.filter(member => member.userId !== data.userId);
        this.membersList.next(updatedMembers);
        
        // Update tempmembersData for search functionality
        this.tempmembersData = updatedMembers;
        
        // Update membersData count
        this.membersData = updatedMembers.length;

        Swal.fire({
          position: "center",
          icon: "success",
          title: "Invitation cancelled",
          showConfirmButton: false,
          timer: 2000,
        });
        // Refresh from the server so the badge count (derived from this response)
        // reflects the cancellation, same as Workspace's Invites Sent page.
        this.resetPayload();
        this.getInviteList();
      }
  },err => {
      this.util.stopLoader();

     });

  }

  canShow(data, source) {
    return true;
  }

  sort_by_key(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  onSearchInvite(v : string){
    this.searchSubject.next(v);
  }

  onScrollDown(){
    if(!this.stopScroll){
      this.loadScroll = true;
      this.scrollSubject.next(this.previouseAfterKey);
    }
  }
}


